<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Musical Theatre
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p><strong>Musical Theatre</strong> recorded $442.3m in revenue and close to 3.7m attendances in 2025.</p>
          <p><strong>Musical Theatre</strong> recorded a y-o-y decline in revenue of 16.8% (from $531.6m in 2024 to $442.3m in 2025) and a y-o-y decline in attendance of 16.6% (from 4.4m in 2024 to 3.7m in 2025). The average ticket price decreased marginally by 0.2% y-o-y (from $127.43 in 2024 to $127.15 in 2025).</p>
          <p><strong>Musical Theatre</strong> accounted for the second-largest market share in both revenue (13.2%) and attendance (11.9%) within the live performance industry in 2025. However, its share of the overall live performance market declined compared with 2024, when the category accounted for 15.9% of revenue and 13.9% of attendance.</p>
          <p>Top events in this category in 2025 were <em>MJ the Musical</em>, <em>Beetlejuice the Musical</em>, <em>The Book of Mormon</em>, <em>Jesus Christ Superstar</em> and <em>Beauty and the Beast</em>.</p>
        </div>
        <div class="sixcol last">
          <p>VIC and NSW accounted for the majority of revenue and attendance in this category. Combined, they generated 72.0% market share of revenue and 70.5% market share of attendance in this category in 2025.</p>
          <p>Major events in VIC included <em>MJ the Musical</em>, <em>Beetlejuice the Musical</em>, <em>Jesus Christ Superstar</em>, <em>Beauty and the Beast</em>, <em>Annie</em> and <em>The Tina Turner Musical</em>. Major events in NSW included <em>MJ the Musical</em>, <em>The Book of Mormon</em>, <em>Les Misérables</em> and <em>Hadestown</em>.</p>
          <p>The overall decline in this category in 2025 was primarily driven by declines across the major markets, particularly VIC, NSW and QLD. VIC recorded a y-o-y decline of 17.1% in revenue and 13.6% in attendance, NSW recorded a y-o-y decline of 15.6% in revenue and 20.6% in attendance, and QLD recorded a y-o-y decline of 30.7% in revenue and 30.0% in attendance.</p>
          <p>All states and territories except WA and NT recorded a y-o-y decline in revenue and attendance in 2025.</p>
          <p>In 2025, NT recorded the highest y-o-y increase in revenue (236.0%) and attendance (270.6%). However, its overall impact remains minimal, contributing only 0.1% to the total revenue and 0.2% to the total attendance in this category.</p>
          <p>WA recorded the second-highest y-o-y increase in revenue (24.9%) and attendance (15.5%). Major events in WA included <em>Beauty and the Beast</em>, <em>Wicked</em>, <em>Cats</em>, <em>Sister Act</em> and <em>Jesus Christ Superstar</em>.</p>
        </div>
      </div>
    </article>
    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="classical-music-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.<br>Categories/States with zero or &lt;0.05% of revenue and/or attendance<br> may not be reflected in the pie chart.</div>
        </div>
      </div>
    </figure>

    <div class="row clearfix">
      <h2 id="download-btn">Download the Report</h2>
      <div class="execsumm" style="justify-content: center;">
        <a href="./pdf/2025/MUSICAL THEATRE  Live Performance Industry in 2025.pdf" class="button fullreport pdf" target="_blank">
          Musical Theatre Infographic Report 2025 (PDF)
        </a>
      </div>
    </div>

    <div class="fullbg">
      <p class="caption">Photo: <em>Pretty Woman The Musical</em>, Jones Theatrical, Photo Credit: Daniel Boud</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter: function() {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(2) + 'b'
            } else {
              revy = '$' + rev.y.toFixed(3) + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'center',
          verticalAlign: 'bottom',
          floating: false,
          backgroundColor: '#FFFFFF'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [138.719, 178.032, 235.923, 228.855, 252.199, 214.96, 242.897, 246.792, 203.279, 193.39, 320.342, 334.869, 347.684, 416.803, 400.2, 337.338, 67.052, 202.343, 519.021, 542.172, 531.588, 442.299],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [1.848, 2.46, 2.806, 3.359, 3.13, 2.458, 2.613, 2.8, 2.224, 2.085, 3.182, 3.259, 3.298, 4.042, 3.918, 3.452, 0.729, 1.785, 4.270, 4.289, 4.379, 3.651],
          color: '#d14967'
        }]
      },
      activeYear: 2025,
      stateBreakdowns: [
        {
          year: 2025,
          revenue: [
            ["NSW", 33.6],
            ["VIC", 38.4],
            ["QLD", 13.0],
            ["WA", 9.7],
            ["SA", 5.0],
            ["ACT", 0.2],
            ["TAS", 0.0],
            ["NT", 0.09],
          ],
          attendance: [
            ["NSW", 33.0],
            ["VIC", 37.5],
            ["QLD", 12.8],
            ["WA", 10.2],
            ["SA", 6.0],
            ["ACT", 0.3],
            ["TAS", 0.1],
            ["NT", 0.16],
          ]
        }
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [
              {
                name: 'Attendance Share',
                data: stateBreakdown.attendance,
                size: '68%',
                innerSize: '40%',
                borderColor: 'none',
                borderWidth: 1,
                slicedOffset: 30,
                showInLegend: true,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -28
                }
              }, 
              {
                name: 'Revenue Share',
                data: stateBreakdown.revenue,
                size: '100%',
                innerSize: '70%',
                borderColor: 'transparent',
                borderWidth: 1,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -32
                }
              }
            ],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url("~@/assets/img/2025/26-Musical-Theatre-Pretty-Woman-The-Musical-Australia---Photography-by-Daniel-Boud-(2).jpg");
  background-position: top center;
}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
